import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import LoginPage from "./Components/LoginPage";
import ProtectedRoute from "./Components/ProtectedRoute";
import Home from "./Components/Home";
import AdminCarrers from "./Components/AdminCareer";
import AdminOTC from "./Components/AdminOTC";
import Careers from "./Components/Careers";
import CareerDetail from "./Components/CareerDetail";
import AboutUs from "./Components/AboutUs";
import History from "./Components/History";
import './App.css'; // Adjust the path if needed
import ContactUs from "./Components/ContactUs";
import useProducts from "./Hooks/useProducts";
import LoadingSpinner from "./Assets/LoadingSpinner";
import ProductDetail from "./Components/ProductDetail";
import NotFound from "./Assets/NotFound";
import ScrollToTop from "./Assets/ScrollToTop";
import AdminAboutUs from "./Components/AdminAboutUs";
import AdminDosage from "./Components/AdminDosage";
import AdminContactInfo from "./Components/AdminContactInfo";
import AdminHistory from "./Components/AdminHistory";
import ParentProduct from "./Components/ParentCategory";
import ErrorComponent from "./Assets/ErrorComponent";
import UnderConstruction from "./Components/UnderConstruction";
import { useTranslation } from "react-i18next";
import AdminUsers from "./Components/AdminUsers";
import News from "./Components/News";
import NewsDetail from "./Components/NewsDetail";
import Blog from "./Components/Blog";
import BlogDetail from "./Components/BlogDetail";
import AdminNews from "./Components/AdminNews";
import AdminBlog from "./Components/AdminBlog";


const App: React.FC = () => {

  const { t } = useTranslation();
  const underConstruction = false;

  const { products, loading, error } = useProducts();
  const lang = localStorage.getItem("lang") || "en";

  if (underConstruction) {
    return <UnderConstruction />;
  }



  if (loading) {
    return (
      <LoadingSpinner />

    );
  }

  if (error) {
    return (
      <ErrorComponent message={error} />
    );
  }

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={<Home products={products} lang={lang} />}
        />
        <Route
          path="/about"
          element={<AboutUs products={products} lang={lang} />}
        />
        <Route
          path="/history"
          element={<History products={products} lang={lang} />}
        />
        <Route path="/parent/:id" element={<ParentProduct products={products} lang={lang} />} />
        <Route path="/product/:id" element={<ProductDetail products={products} lang={lang} />} />
        <Route
          path="/careers"
          element={<Careers products={products} lang={lang} />}
        />
        <Route path="/careers/:id" element={<CareerDetail products={products} lang={lang} />} />
        <Route
          path="/contacts"
          element={<ContactUs products={products} lang={lang} />}
        />
        <Route path="/contact" element={<Navigate to="/contacts" replace />} />

        <Route path="/news" element={<News products={products} lang={lang} />} />
        <Route path="/news/:id" element={<NewsDetail products={products} lang={lang} />} />
        <Route path="/blog" element={<Blog products={products} lang={lang} />} />
        <Route path="/blog/:id" element={<BlogDetail products={products} lang={lang} />} />

        <Route path="*" element={<NotFound />} />


        <Route
          path="/admin/products/medical-products/otc"
          element={<ProtectedRoute component={(props) => <AdminOTC {...props} product="Medicinal%20Products/OTC" name={t('subcategories.OTC')} category="OTC" lang={lang} />} />}
        />



        <Route
          path="/admin/products/cbd/oral"
          element={<ProtectedRoute component={(props) => <AdminOTC {...props} product="CBD%20Products/Oral"
            lang={lang}
            name={`${t('products.cbd')} - ${t('subcategories.Oral')}`}
            category="Oral" />}
          />}
        />

        <Route
          path="/admin/products/cbd/topical"
          element={<ProtectedRoute component={(props) => <AdminOTC {...props} product="CBD%20Products/Topical"
            lang={lang}
            name={`${t('products.cbd')} - ${t('subcategories.Topical')}`}
            category="Topical" />} />}
        />

        <Route
          path="/admin/products/cbd/cosmetics"
          element={<ProtectedRoute component={(props) => <AdminOTC {...props}
            product="CBD%20Products/Cosmetics"
            lang={lang}
            name={`${t('products.cbd')} - ${t('subcategories.Cosmetics')}`}
            category="Cosmetics" />} />}
        />


        <Route
          path="/admin/products/dietary-supplements/galahealth"
          element={<ProtectedRoute component={(props) => <AdminOTC {...props}
            product="Dietary%20Supplements/GALAHEALTH"
            name="GALAHEALTH"
            category="GALAHEALTH"
            lang={lang}

          />} />}
        />


        <Route
          path="/admin/products/dietary-supplements/jekogal"
          element={<ProtectedRoute component={(props) => <AdminOTC {...props}
            product="Dietary%20Supplements/JEKOGAL"
            name="JEKOGAL"
            category="JEKOGAL"
            lang={lang}
          />} />}
        />

        <Route
          path="/admin/products/dietary-supplements/galapro"
          element={<ProtectedRoute component={(props) => <AdminOTC {...props}
            product="Dietary%20Supplements/GALAPRO"
            name="GALAPRO"
            category="GALAPRO"
            lang={lang}
          />} />}
        />




        <Route
          path="/admin/products/herbal-products"
          element={<ProtectedRoute component={(props) => <AdminOTC {...props} product="Herbal%20Products" name={t('products.herbal')} category="Herbal Products" />} />}
        />

        <Route
          path="/admin/products/personal-care/babygal-baby-skin-care"
          element={<ProtectedRoute component={(props) => <AdminOTC {...props} product="BABYGAL%20Baby%20Skin Care" name="BABYGAL Baby Skin Care" category="BABYGAL Baby Skin Care" />} />}
        />

        <Route
          path="/admin/products/personal-care/face--lip-care"
          element={<ProtectedRoute component={(props) => <AdminOTC {...props} product="FACE%20&%20LIP%20CARE" name="FACE & LIP CARE" category="FACE & LIP CARE" />} />}
        />

        <Route
          path="/admin/products/personal-care/sensilis-mam-care"
          element={<ProtectedRoute component={(props) => <AdminOTC {...props} product="SENSILIS%20MAM%20CARE" name="SENSILIS MAM CARE" category="SENSILIS MAM CARE" />} />}
        />

        <Route
          path="/admin/products/personal-care/sensilis-foot-care"
          element={<ProtectedRoute component={(props) => <AdminOTC {...props} product="SENSILIS%20FOOT%20CARE" name="SENSILIS FOOT CARE" category="SENSILIS FOOT CARE" />} />}
        />

        <Route
          path="/admin/products/personal-care/sensilis-nail--hand-care"
          element={<ProtectedRoute component={(props) => <AdminOTC {...props} product="SENSILIS%20NAIL%20&%20HAND%20CARE" name="SENSILIS NAIL & HAND CARE" category="SENSILIS NAIL & HAND CARE" />} />}
        />

        <Route
          path="/admin/products/personal-care/sensilis-oils"
          element={<ProtectedRoute component={(props) => <AdminOTC {...props} product="SENSILIS%20OILS" name="SENSILIS OILS" category="SENSILIS OILS" />} />}
        />

        <Route
          path="/admin/products/personal-care/silk-hair-removal"
          element={<ProtectedRoute component={(props) => <AdminOTC {...props} product="SILK%20HAIR%20REMOVAL" name="SILK HAIR REMOVAL" category="SILK HAIR REMOVAL" />} />}
        />

        <Route
          path="/admin/products/personal-care/solarus-sun-protection-care"
          element={<ProtectedRoute component={(props) => <AdminOTC {...props} product="SOLARUS%20SUN%20PROTECTION%20CARE" name="SOLARUS SUN PROTECTION CARE" category="SOLARUS SUN PROTECTION CARE" />} />}
        />

        <Route
          path="/admin/products/personal-care/citrogala-inspect-protection"
          element={<ProtectedRoute component={(props) => <AdminOTC {...props} product="CITROGALA%20INSPECT%20PROTECTION" name="CITROGALA INSPECT PROTECTION" category="CITROGALA INSPECT PROTECTION" />} />}
        />


        <Route
          path="/admin/contacts"
          element={<ProtectedRoute component={(props) => <AdminContactInfo {...props} lang={lang} />} />}

        />

        <Route
          path="/admin/careers/vacancy"
          element={<ProtectedRoute component={(props) => <AdminCarrers {...props} lang={lang} />} />}

        />

        <Route
          path="/admin/who-we-are/about"
          element={<ProtectedRoute component={(props) => <AdminAboutUs {...props} lang={lang} />} />}

        />

        <Route
          path="/admin/who-we-are/history"
          element={<ProtectedRoute component={(props) => <AdminHistory {...props} lang={lang} />} />}

        />

        <Route
          path="/admin/home/dosage"
          element={<ProtectedRoute component={(props) => <AdminDosage {...props} lang={lang} />} />}

        />


        <Route
          path="/admin/users"
          element={<ProtectedRoute component={(props) => <AdminUsers {...props} lang={lang} />} />}

        />

        <Route
          path="/admin/news"
          element={<ProtectedRoute component={(props) => <AdminNews {...props} lang={lang} />} />}
        />

        <Route
          path="/admin/blog"
          element={<ProtectedRoute component={(props) => <AdminBlog {...props} lang={lang} />} />}
        />


      </Routes>
    </Router>
  );
};

export default App;
